var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-base',{attrs:{"width":100+'%',"fill":_vm.color,"viewBox":"0 0 599.99 105.129"}},[_c('path',{attrs:{"id":"Path_3079","data-name":"Path 3079","d":"M1009.317,1055.506s160.394,170.886,599.044,73.378","transform":"translate(-1008.588 -1054.822)","fill":"none","stroke":"#eaca42","stroke-width":"3","opacity":"0.6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }